var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { createRepositories, NotImplementedAuthRepository, NotImplementedCountriesRepository, NotImplementedFamilyRepository, NotImplementedFavouriteRepository, NotImplementedInAppPurchaseRepository, NotImplementedMealPrepRepository, NotImplementedNotificationsRepository, NotImplementedPlanRepository, NotImplementedRecipeRepository, NotImplementedRedeemCouponRepository, NotImplementedShoppingListRepository, NotImplementedUserRepository, } from '../../repositories';
import { useStorage } from '../StorageContext/useStorage';
import { useErrorHandler } from '../ErrorHandlerContext/useErrorHandler';
import { NotImplementedCustomerRepository, } from '../../repositories/customer/ICustomerRepository';
import { NotImplementedCodeRepository, } from '../../repositories/code/ICodeRepository';
import { NotImplementedIngredientRepository, } from '../../repositories/ingredients/IIngredientsRepository';
import { NotImplementedActivityRepository, } from '../../repositories/activity/IActivityRepository';
import { useLanguage } from '../../locale';
import { NotImplementedFiltersRepository } from '../../repositories/filters/IFiltersRepository';
import { NotImplementedCalorieRangeRepository, } from '../../repositories/calorieRange/ICalorieRangeRepository';
import { StorageKeys } from '../../services';
import { useDispatch, useSelector } from 'react-redux';
import { GeneralActions, getUserTimeZone } from '../../redux';
import { Servers } from '../../models';
import { MULTITENANT_ENABLED } from '../../utils/featureFlags';
export var RepositoriesContext = createContext({
    authRepo: new NotImplementedAuthRepository(),
    userRepo: new NotImplementedUserRepository(),
    countriesRepo: new NotImplementedCountriesRepository(),
    customerRepo: new NotImplementedCustomerRepository(),
    codeRepo: new NotImplementedCodeRepository(),
    ingredientRepo: new NotImplementedIngredientRepository(),
    activityRepo: new NotImplementedActivityRepository(),
    recipeRepo: new NotImplementedRecipeRepository(),
    familyRepo: new NotImplementedFamilyRepository(),
    favouriteRepo: new NotImplementedFavouriteRepository(),
    planRepo: new NotImplementedPlanRepository(),
    filtersRepo: new NotImplementedFiltersRepository(),
    calorieRangeRepo: new NotImplementedCalorieRangeRepository(),
    shoppingListRepo: new NotImplementedShoppingListRepository(),
    notificationsRepo: new NotImplementedNotificationsRepository(),
    inAppPurchaseRepo: new NotImplementedInAppPurchaseRepository(),
    redeemCouponRepo: new NotImplementedRedeemCouponRepository(),
    mealPrepRepo: new NotImplementedMealPrepRepository(),
});
export var RepositoriesProvider = function (_a) {
    var _b, _c, _d;
    var children = _a.children, cognitoRegion = _a.cognitoRegion, userPoolWebClientId = _a.userPoolWebClientId, repositoriesInstances = _a.repositoriesInstances, baseUrl = _a.baseUrl, planterApiKey = _a.planterApiKey;
    var _e = useState(false), isInitialized = _e[0], setIsInitialized = _e[1];
    var tokensRef = useRef({ accessToken: null, refreshToken: null });
    var planterHttpClientRef = useRef(null);
    var t = useLanguage()[0];
    var locale = useLanguage()[2];
    var storage = useStorage();
    var dispatch = useDispatch();
    var errorHandler = useErrorHandler();
    var userTimezone = MULTITENANT_ENABLED
        ? useSelector(getUserTimeZone)
        : undefined;
    var baseUrlProcessed = MULTITENANT_ENABLED
        ? userTimezone === Servers.america
            ? (_b = baseUrl[Servers.america]) !== null && _b !== void 0 ? _b : baseUrl[Servers.europe]
            : baseUrl[Servers.europe]
        : baseUrl[Servers.europe];
    var cognitoRegionProcessed = MULTITENANT_ENABLED
        ? userTimezone === Servers.america
            ? (_c = cognitoRegion[Servers.america]) !== null && _c !== void 0 ? _c : cognitoRegion[Servers.europe]
            : cognitoRegion[Servers.europe]
        : cognitoRegion[Servers.europe];
    var userPoolWebClientIdProcessed = MULTITENANT_ENABLED
        ? userTimezone === Servers.america
            ? (_d = userPoolWebClientId[Servers.america]) !== null && _d !== void 0 ? _d : userPoolWebClientId[Servers.europe]
            : userPoolWebClientId[Servers.europe]
        : userPoolWebClientId[Servers.europe];
    useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, refreshToken, userTenant, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, storage.getItem(StorageKeys.ACCESS_TOKEN_KEY)];
                    case 1:
                        accessToken = _b.sent();
                        return [4 /*yield*/, storage.getItem(StorageKeys.REFRESH_TOKEN_KEY)];
                    case 2:
                        refreshToken = _b.sent();
                        if (!MULTITENANT_ENABLED) return [3 /*break*/, 4];
                        return [4 /*yield*/, storage.getItem(StorageKeys.USER_TIME_ZONE)];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _a = Servers.europe;
                        _b.label = 5;
                    case 5:
                        userTenant = _a;
                        tokensRef.current = { accessToken: accessToken, refreshToken: refreshToken };
                        // Dispatch timezone BEFORE isInitialized so the first render that
                        // opens the Gatekeeper already has the correct baseUrlProcessed.
                        if (MULTITENANT_ENABLED) {
                            if (userTenant) {
                                dispatch(GeneralActions.setUserTimezone(userTenant));
                            }
                        }
                        else {
                            dispatch(GeneralActions.setUserTimezone(Servers.europe));
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        run().finally(function () { return setIsInitialized(true); });
    }, [dispatch, storage]);
    // Ref per tracciare l'ultima sincronizzazione dei token per evitare loop infiniti
    var lastSyncedTokensRef = useRef(null);
    // Ref per tracciare l'ultimo PlanterHttpClient sincronizzato
    var lastSyncedHttpClientRef = useRef(null);
    // Ref per memorizzare lo storage per evitare che cambi riferimento causi loop
    var storageRef = useRef(storage);
    storageRef.current = storage;
    // Sincronizza i token quando i repository vengono creati/ricreati o quando isInitialized diventa true
    // Questo garantisce che il PlanterHttpClient abbia sempre i token più aggiornati dallo storage
    useEffect(function () {
        if (!isInitialized ||
            !planterHttpClientRef.current ||
            repositoriesInstances) {
            return;
        }
        var syncTokens = function () { return __awaiter(void 0, void 0, void 0, function () {
            var currentHttpClient, accessToken, refreshToken, lastSynced;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentHttpClient = planterHttpClientRef.current;
                        if (!currentHttpClient) {
                            return [2 /*return*/];
                        }
                        // Se il PlanterHttpClient è cambiato, resetta lastSyncedTokensRef per permettere la sincronizzazione
                        if (lastSyncedHttpClientRef.current !== currentHttpClient) {
                            lastSyncedTokensRef.current = null;
                            lastSyncedHttpClientRef.current = currentHttpClient;
                        }
                        return [4 /*yield*/, storageRef.current.getItem(StorageKeys.ACCESS_TOKEN_KEY)];
                    case 1:
                        accessToken = _a.sent();
                        return [4 /*yield*/, storageRef.current.getItem(StorageKeys.REFRESH_TOKEN_KEY)];
                    case 2:
                        refreshToken = _a.sent();
                        lastSynced = lastSyncedTokensRef.current;
                        if (lastSynced &&
                            lastSynced.accessToken === accessToken &&
                            lastSynced.refreshToken === refreshToken) {
                            // I token non sono cambiati, non fare nulla per evitare loop
                            return [2 /*return*/];
                        }
                        // Aggiorna tokensRef.current con i token letti dallo storage
                        tokensRef.current = { accessToken: accessToken, refreshToken: refreshToken };
                        lastSyncedTokensRef.current = { accessToken: accessToken, refreshToken: refreshToken };
                        // Configura il PlanterHttpClient con i token dallo storage
                        if (currentHttpClient) {
                            if (accessToken) {
                                currentHttpClient.setupAuth(accessToken, refreshToken || undefined);
                            }
                            else {
                                // Se non ci sono token, rimuovi l'autenticazione
                                currentHttpClient.removeAuth();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        syncTokens();
    }, [
        isInitialized,
        repositoriesInstances,
        // Aggiungiamo le dipendenze del useMemo per eseguire questo effect quando i repository vengono ricreati
        baseUrlProcessed,
        cognitoRegionProcessed,
        userPoolWebClientIdProcessed,
    ]);
    var handleCountryDetected = useCallback(function (countryCode) {
        dispatch(GeneralActions.setDetectedCountryCode(countryCode));
    }, [dispatch]);
    var repositories = useMemo(function () {
        if (repositoriesInstances) {
            return repositoriesInstances;
        }
        // Non creare i repository finché i token non sono stati caricati dallo storage
        // Questo previene chiamate API senza header corretti
        if (!isInitialized) {
            return null;
        }
        // Garantire che locale sia sempre definito (fallback a 'it')
        // Questo previene chiamate senza header 'lang'
        var localeToUse = locale || 'it';
        var repos = createRepositories({
            storage: storage,
            errorHandler: errorHandler,
            baseUrl: baseUrlProcessed,
            cognitoRegion: cognitoRegionProcessed,
            userPoolWebClientId: userPoolWebClientIdProcessed,
            locale: localeToUse,
            t: t,
            onCountryDetected: handleCountryDetected,
            // Passa sempre i token da tokensRef.current (che vengono sincronizzati dallo storage)
            accessToken: tokensRef.current.accessToken,
            refreshToken: tokensRef.current.refreshToken,
            planterApiKey: planterApiKey,
        });
        // Salva il riferimento al PlanterHttpClient per aggiornare il locale
        planterHttpClientRef.current = repos.planterHttpClient;
        return repos;
        // Nota: locale e t non sono nelle dipendenze perché vengono aggiornati dinamicamente
        // tramite updateLocale e updateTranslation per evitare la ricreazione dei repository
        // I token vengono sincronizzati dal useEffect che legge dallo storage
        // isInitialized è nelle dipendenze per garantire che i repository vengano creati solo quando i token sono pronti
    }, [
        baseUrlProcessed,
        cognitoRegionProcessed,
        errorHandler,
        handleCountryDetected,
        isInitialized,
        planterApiKey,
        repositoriesInstances,
        storage,
        userPoolWebClientIdProcessed,
    ]);
    // Aggiornare l'header lang e la funzione di traduzione quando cambia il locale senza ricreare i repository
    // Questo evita di perdere i token quando il locale cambia
    useEffect(function () {
        if (planterHttpClientRef.current && !repositoriesInstances) {
            planterHttpClientRef.current.updateLocale(locale);
            planterHttpClientRef.current.updateTranslation(t);
        }
    }, [locale, t, repositoriesInstances]);
    if (!repositories || !isInitialized) {
        return null;
    }
    return (_jsx(RepositoriesContext.Provider, { value: repositories, children: children }));
};
